import React from 'react'

import './index.scss'

//material-ui
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import { IconButton, Toolbar, Typography } from '@material-ui/core'
import { Close } from '@material-ui/icons'

//custom components
import ProductWarehouseScanner from '../../../../../components/complex/ProductWarehouseScanner'
//api

//other libraries
import { inject, observer } from 'mobx-react'

@inject('internal')
@inject('translate')
@observer
export default class ScanProduct extends React.Component {
  render() {
    return (
      <Dialog
        fullScreen
        open={this.props.open}
        onClose={this.props.onClose}>
        <Toolbar>
          <Typography variant="h6" color="inherit" className={'flex-1'}>
            Vyskladnenie produktu
          </Typography>
          <IconButton color="inherit" onClick={this.props.onClose} aria-label="Close">
            <Close/>
          </IconButton>
        </Toolbar>
        <DialogContent>
          <ProductWarehouseScanner
            mode={'from_storage'}
            saveOther={{
              issue_card_id: this.props.issueCardId
            }}
            handleAfterSave={this.props.handleAfterSave}
          />
        </DialogContent>
      </Dialog>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/IssueCards/detail/products/scanProduct/index.js